export async function ImageEmissora(token: string | null,nLoading: string | null) { 
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + `api/imageemissora?ultimoNLoading=${nLoading}`,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const response = await axios.request(options);
    return response;
}
